import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { AuthFacade } from '@core/services/auth-facade';
import { Notifier } from '@core/services/notifier';
import { filter, switchMap, take } from 'rxjs';
import { AuthAccessResult, ensureAuthAccess } from './auth-guard-utils';

export const authGuard: CanActivateFn = (route, state) => {
  const authFacade = inject(AuthFacade);
  const notifier = inject(Notifier);

  return toObservable(authFacade.isAuthenticated).pipe(
    filter((value) => value != null),
    take(1),
    switchMap(async (isAuthenticated) => {
      const result = await ensureAuthAccess(authFacade, isAuthenticated, state.url);
      if (result === AuthAccessResult.TemporaryFailure) {
        notifier.error({
          title: 'Authentication check failed. Please try again.',
          description: 'We could not validate your session right now.',
        });
      }
      return result === AuthAccessResult.Allowed;
    }),
  );
};
